import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ModalIntentType } from 'src/app/enum/modal-intent-type.enum';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  @Output() closeModalClick = new EventEmitter();
  @Output() confirmModalClick = new EventEmitter();
  @Input() QuestionText: string;
  @Input() MessageText: string;
  @Input() HeaderText: string;
  @Input() ButtonConfirmText: string;
  @Input() ButtonCancelText: string;
  @Input() IsApprovalConfirm: boolean;
  @Input() modalIntentType: ModalIntentType;

  constructor() { }

  ngOnInit() {
  }

  modalClose() {
    this.closeModalClick.emit();
  }

  modalConfirm() {
    this.confirmModalClick.emit();
  }
}
